// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AccordionMinus: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 21 3" width={width} height={height}>
            <path
                fill="currentColor"
                d="M20.25 1.25c0 .55-.346 1-.77 1H1.02c-.424 0-.77-.45-.77-1s.346-1 .77-1h18.46c.424 0 .77.45.77 1"
            />
        </svg>
    );
};

export default React.memo(AccordionMinus);
